import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EntityEditorModule } from '../entity-editor/entity-editor.module';
import { SharedModule } from '../shared/shared.module';
import { UserSettingsViewComponent } from './views/user-settings-view/user-settings-view.component';
import { UserSettingsFormComponent } from './components/user-settings-form/user-settings-form.component';
import { StoreModule } from '@ngrx/store';
import { userAccountReducer } from './store';
import { EffectsModule } from '@ngrx/effects';
import { UserSettingsEntityEffects } from './store/user-settings-entity/user-settings-entity.effects';
import { UserSettingsEffects } from './store/user-settings/user-settings.effects';
import { ChangePasswordViewComponent } from './views/change-password-view/change-password-view.component';
import { RouterLink } from '@angular/router';
import { UserPasswordEffects } from './store/user-password/user-password.effects';

@NgModule({
  declarations: [UserSettingsViewComponent, UserSettingsFormComponent, ChangePasswordViewComponent],
  imports: [
    CommonModule,
    SharedModule,
    EntityEditorModule,
    StoreModule.forFeature('userAccount', userAccountReducer),
    EffectsModule.forFeature([UserSettingsEntityEffects, UserSettingsEffects, UserPasswordEffects]),
    RouterLink
  ],
  exports: [UserSettingsViewComponent]
})
export class UserAccountModule {}
